module.exports = __webpack_public_path__ + "static/media/CanadianAlertingAttentionSignal.7238e76a.mp3";